import { Body, Controller, Post } from '@nestjs/common';
import { ApiBody, ApiTags } from '@nestjs/swagger';
import { IndentService } from './indent.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { IndentDto } from './dto/indent.dto';
import { AllIndentReportResponse, AllIndentsResponseModel, GetHarvestingResponseModel, GrnCompletedStatusResponse, GrnStatusUpdate, HarvestReportResponse, IndentAckResponse, IndentDropdownResponse, IndentHarvestingDateRangeReq, IndentHarvestingDateReq, indentIdReq, IndentModel, IndentQtyResponse, IndentRequest, IndentResponse, IndentResponseModel, RmCountReq} from '@gtpl/shared-models/raw-material-procurement';
import { UpdateVehicleStatusRequest } from './dto/update-vehicle-status.request';
import { Indent } from './indent.entity';
import { IndentIdRequest } from './dto/indent-id.request';
import { PlantRequest } from './dto/plant.request';
import { IndentReportRequest } from './dto/indent-request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { IndentQuantityRequest } from './dto/indent-qty.request';
import { HarvestDto } from './dto/harvest.dto';
import { HarvestIdRequest } from './dto/harvest-id.request';
import { IndentDetailsDto } from './dto/indent-details.dto';
import { IndentAbstractRequest } from './dto/indent-abstract';
import {CommonResponse as Response} from 'libs/shared-models/sale-management/src'

@ApiTags('indent')
@Controller('indent')
export class IndentController {
    constructor(private indentService: IndentService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    /**
     * calling a service to create a new indent
     * @param indentDto 
     * @returns 
     */
    @Post('/createIndent')
    async createIndent(@Body() indentDto: IndentDetailsDto): Promise<IndentResponseModel>  {
        try {
            return await this.indentService.createIndent(indentDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(IndentResponseModel, error);
        }
    }

    /**
     * calling a service to update a existing Indent
     * @param indentDto 
     * @returns 
     */
    @Post('/updateIndent')
    async updateIndent(@Body() indentDto: IndentDetailsDto): Promise<IndentResponseModel>  {
        try {
            return await this.indentService.createIndent(indentDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(IndentResponseModel, error);
        }
    }

    /**
     * calling a service to get all indents
     * @param indentDto 
     * @returns 
     */
    @Post('/getAllIndents')
    async getAllIndents(@Body() req:IndentHarvestingDateRangeReq): Promise<AllIndentsResponseModel>  {
        try {
            return await this.indentService.getAllIndents(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllIndentsResponseModel, error);
        }
    }
    

    /**
     * calling service to get indents for dropdown
     * @returns 
     */
    @Post('/getIndentsForDropdown')
    async getIndentsForDropdown(): Promise<IndentDropdownResponse> {
        try {
        return await this.indentService.getIndentsForDropdown();
        } catch (error) {
        return this.applicationExceptionHandler.returnException(IndentDropdownResponse, error);
        }
    }

    /**
     * 
     * @param updateVehicleStatusRequest 
     * @returns 
     */
    @Post('/updateVehicleStatus')
    async updateVehicleStatus(@Body() updateVehicleStatusRequest: UpdateVehicleStatusRequest): Promise<any> {
        try {
        return await this.indentService.updateVehicleStatus(updateVehicleStatusRequest);
        } catch (error) {
            return error;
        }
    }

    /**
     * calling a service to get indents details
     * @param indentIdReq 
     * @returns 
     */
     @Post('/getIndentDetailsById')
     async getIndentDetailsById(@Body() indentIdReq: IndentIdRequest): Promise<IndentResponse>  {
         try {
             return await this.indentService.getIndentDetailsById(indentIdReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(IndentResponse, error);
         }
     }

     @Post('/updateGrnCompletedStatus')
     async updateGrnCompletedStatus(@Body() grnInfo: GrnStatusUpdate): Promise<GrnCompletedStatusResponse>  {
         try {
             return await this.indentService.updateGrnCompletedStatus(grnInfo);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(GrnCompletedStatusResponse, error);
         }
     }

     @Post('/activateOrDeactivateIndent')
     async activateOrDeactivateIndent(@Body() indentReq: IndentIdRequest): Promise<IndentAckResponse>  {
         try {
             return await this.indentService.activateOrDeactivateIndent(indentReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(IndentAckResponse, error);
         }
     }

     @Post('/getProductCountWiseIndentQty')
     async getProductCountWiseIndentQty(@Body() inputReq: IndentQuantityRequest): Promise<IndentQtyResponse>  {
         try {
             return await this.indentService.getProductCountWiseIndentQty(inputReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(IndentQtyResponse, error);
         }
     }

     @Post('getIndentItemDataById')
     async getIndentItemDataById(@Body() req:indentIdReq ): Promise<CommonResponse> {
        try {
            return await this.indentService.getIndentItemDataById(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
     }
     
     @Post('/getHarvestinData')
     async getHarvestinData(@Body() inputReq: PlantRequest): Promise<GetHarvestingResponseModel>  {
         try {
             return await this.indentService.getHarvestinData(inputReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(GetHarvestingResponseModel, error);
         }
     }
     @Post('/cancelAssignedVehicle')
     async cancelAssignedVehicle(@Body() inputReq: IndentModel): Promise<CommonResponse>  {
         try {
             return await this.indentService.cancelAssignedVehicle(inputReq);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }


     /**
     * calling a service to get all indents for report
     * @param indentDto 
     * @returns 
     */
    @Post('/getIndentReportDetails')
    async getIndentReportDetails(@Body() req?:IndentReportRequest): Promise<AllIndentReportResponse>  {
        try {
            return await this.indentService.getIndentReportDetails(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllIndentReportResponse, error);
        }
    }

    @Post('/getIndentQty')
     async getIndentQty(): Promise<IndentQtyResponse>  {
         try {
             return await this.indentService.getIndentQty();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(IndentQtyResponse, error);
         }
     }

     @Post('/getPendingGrnQty')
     async getPendingGrnQty(): Promise<IndentQtyResponse>  {
         try {
             return await this.indentService.getPendingGrnQty();
         } catch (error) {
             return this.applicationExceptionHandler.returnException(IndentQtyResponse, error);
         }
     }

     @Post('/createHarvestReport')
     async createHarvestReport(@Body() harvestDto:HarvestDto): Promise<HarvestReportResponse>  {
         try {
             return await this.indentService.createHarvestReport(harvestDto);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(HarvestReportResponse, error);
         }
     }

     @Post('/getHarvestReport')
     async getHarvestReport(@Body() harvestIdRequest:HarvestIdRequest): Promise<HarvestReportResponse>  {
         try {
             return await this.indentService.getHarvestReport(harvestIdRequest);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(HarvestReportResponse, error);
         }
     }

     @Post('/getIndentDataById')
     async getIndentDataById(@Body() indentRequest:IndentIdRequest): Promise<CommonResponse>  {
         try {
             return await this.indentService.getIndentDataById(indentRequest);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }
     @Post('/openOrCloseGrn')
     async openOrCloseGrn(@Body() indentRequest:IndentIdRequest): Promise<CommonResponse>  {
         try {
             return await this.indentService.openOrCloseGrn(indentRequest);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }

     @Post('/getClosedIndents')
     @ApiBody({type:IndentHarvestingDateRangeReq})
     async getClosedIndents(@Body() req:IndentHarvestingDateRangeReq): Promise<AllIndentsResponseModel>  {
         try {
             return await this.indentService.getClosedIndents(req);
         } catch (error) {
             return this.applicationExceptionHandler.returnException(AllIndentsResponseModel, error);
         }
     }
     @Post('/getIndentAbstract')
     async getIndentAbstract(@Body() indentAbstractRequest:IndentAbstractRequest ): Promise<AllIndentsResponseModel>  {
         try {             
            return await this.indentService.getIndentAbstract(indentAbstractRequest);
         } catch (error) {
            return this.applicationExceptionHandler.returnException(AllIndentsResponseModel, error);
         }
     }  
     @Post('/getRMUsageReport')
     async getRMUsageReport(): Promise<CommonResponse>  {
         try {             
            return await this.indentService.getRMUsageReport();
         } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     } 
     
     @Post('/getRmRateAgainstCount')
     async getRmRateAgainstCount(@Body() req: RmCountReq): Promise<CommonResponse>  {
         try {             
            return await this.indentService.getRmRateAgainstCount(req);
         } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     } 
     @Post('/CancelIndent')
     async CancelIndent(@Body() indent:IndentRequest): Promise<CommonResponse>  {
         try {             
            return await this.indentService.CancelIndent(indent);
         } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     }  
     @Post('/getCancelledIndents')
     async getCancelledIndents(@Body() req:IndentHarvestingDateRangeReq): Promise<CommonResponse>  {
         try {             
            return await this.indentService.getCancelledIndents(req);
         } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     } 
     @Post('/getBookingArrivalsData')
     async getBookingArrivalsData(): Promise<CommonResponse>  {
         try {             
            return await this.indentService.getBookingArrivalsData();
         } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     } 
     @Post('/getCountWiseProcurementData')
     async getCountWiseProcurementData(): Promise<CommonResponse>  {
         try {             
            return await this.indentService.getCountWiseProcurementData();
         } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
         }
     } 
     @Post('/getRmRatesGraphData')
     async getRmRatesGraphData(): Promise<Response>  {
         try {             
            return await this.indentService.getRmRatesGraphData();
         } catch (error) {
            return this.applicationExceptionHandler.returnException(Response, error);
         }
     } 
     @Post('/getWtappMsgIndent')
     async getWtappMsgIndent(@Body() req:number): Promise<Response>  {
         try {             
            return await this.indentService.getWtappMsgIndent(req);
         } catch (error) {
            return this.applicationExceptionHandler.returnException(Response, error);
         }
     } 
}
